<div class="sav-section-heading-text">
  @if (level() === 3) {
    <h3>{{ heading() }}</h3>
  } @else {
    <h2>{{ heading() }}</h2>
  }

  @if (subtitle()) {
    <p>{{ subtitle() }}</p>
  }
</div>

<!-- Optional right-hand slot: carousel arrows, a "view all" link, tabs, etc. -->
<ng-content />
